import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t\t\t-webkit-box-orient: vertical;\n\t\t\t-webkit-line-clamp: ", ";\n\t\t\tdisplay: -webkit-box;\n\t\t\toverflow: hidden;\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * External dependencies
 */
import { useContextSystem } from '@wp-g2/context';
import { css, cx } from '@wp-g2/styles';
/**
 * WordPress dependencies
 */

import { useMemo } from '@wordpress/element';
/**
 * Internal dependencies
 */

import * as styles from './styles';
import { TRUNCATE_ELLIPSIS, TRUNCATE_TYPE, truncateContent } from './utils';
/**
 * @typedef Props
 * @property {string} [ellipsis='...'] String to use to truncate the string with.
 * @property {'auto' | 'head' | 'tail' | 'middle' | 'none'} [ellipsizeMode='auto'] Mode to follow.
 * @property {number} [limit=0] Limit.
 * @property {number} [numberOfLines=0] Number of lines.
 */

/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<Props, 'span'>} props
 */

export default function useTruncate(props) {
  var _useContextSystem = useContextSystem(props, 'Truncate'),
      className = _useContextSystem.className,
      children = _useContextSystem.children,
      _useContextSystem$ell = _useContextSystem.ellipsis,
      ellipsis = _useContextSystem$ell === void 0 ? TRUNCATE_ELLIPSIS : _useContextSystem$ell,
      _useContextSystem$ell2 = _useContextSystem.ellipsizeMode,
      ellipsizeMode = _useContextSystem$ell2 === void 0 ? TRUNCATE_TYPE.auto : _useContextSystem$ell2,
      _useContextSystem$lim = _useContextSystem.limit,
      limit = _useContextSystem$lim === void 0 ? 0 : _useContextSystem$lim,
      _useContextSystem$num = _useContextSystem.numberOfLines,
      numberOfLines = _useContextSystem$num === void 0 ? 0 : _useContextSystem$num,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "children", "ellipsis", "ellipsizeMode", "limit", "numberOfLines"]);

  var truncatedContent = truncateContent(typeof children === 'string' ?
  /** @type {string} */
  children : '', {
    ellipsis: ellipsis,
    ellipsizeMode: ellipsizeMode,
    limit: limit,
    numberOfLines: numberOfLines
  });
  var shouldTruncate = ellipsizeMode === TRUNCATE_TYPE.auto;
  var classes = useMemo(function () {
    var sx = {};
    sx.numberOfLines = css(_templateObject(), numberOfLines);
    return cx(shouldTruncate && !numberOfLines && styles.Truncate, shouldTruncate && !!numberOfLines && sx.numberOfLines, className);
  }, [className, numberOfLines, shouldTruncate]);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes,
    children: truncatedContent
  });
}
//# sourceMappingURL=use-truncate.js.map